export default __webpack_public_path__ + "static/media/No Activity_Illustration_SVG.b9514037.svg";